import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _AudioFormatToMimeTyp;

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { createNoDashGuid } from "../../common/Exports";
import { AudioFormatTag } from "./AudioOutputFormat";
var MediaDurationPlaceholderSeconds = 60 * 30;
var AudioFormatToMimeType = (_AudioFormatToMimeTyp = {}, _defineProperty(_AudioFormatToMimeTyp, AudioFormatTag.PCM, "audio/wav"), _defineProperty(_AudioFormatToMimeTyp, AudioFormatTag.MP3, "audio/mpeg"), _AudioFormatToMimeTyp);
/**
 * Represents the speaker playback audio destination, which only works in browser.
 * Note: the playback is based on <a href="https://www.w3.org/TR/media-source/">Media Source Extensions</a>, on most browsers, only mp3 format is supported.
 * @class SpeakerAudioDestination
 * Updated in version 1.12.0
 */

export var SpeakerAudioDestination = /*#__PURE__*/function () {
  function SpeakerAudioDestination(audioDestinationId) {
    _classCallCheck(this, SpeakerAudioDestination);

    this.privPlaybackStarted = false;
    this.privAppendingToBuffer = false;
    this.privMediaSourceOpened = false;
    this.privId = audioDestinationId ? audioDestinationId : createNoDashGuid();
    this.privIsPaused = false;
    this.privIsClosed = false;
  }

  _createClass(SpeakerAudioDestination, [{
    key: "id",
    value: function id() {
      return this.privId;
    }
  }, {
    key: "write",
    value: function write(buffer) {
      if (this.privAudioBuffer !== undefined) {
        this.privAudioBuffer.push(buffer);
        this.updateSourceBuffer();
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.privIsClosed = true;

      if (this.privSourceBuffer !== undefined) {
        this.handleSourceBufferUpdateEnd();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      if (!this.privIsPaused && this.privAudio !== undefined) {
        this.privAudio.pause();
        this.privIsPaused = true;
      }
    }
  }, {
    key: "resume",
    value: function resume() {
      if (this.privIsPaused && this.privAudio !== undefined) {
        this.privAudio.play();
        this.privIsPaused = false;
      }
    }
  }, {
    key: "updateSourceBuffer",
    value: function updateSourceBuffer() {
      if (this.privAudioBuffer !== undefined && this.privAudioBuffer.length > 0 && this.sourceBufferAvailable()) {
        this.privAppendingToBuffer = true;
        var binary = this.privAudioBuffer.shift();

        try {
          this.privSourceBuffer.appendBuffer(binary);
        } catch (error) {
          this.privAudioBuffer.unshift(binary); // tslint:disable-next-line:no-console

          console.log("buffer filled, pausing addition of binaries until space is made");
          return;
        }

        this.notifyPlayback();
      } else if (this.canEndStream()) {
        this.handleSourceBufferUpdateEnd();
      }
    }
  }, {
    key: "handleSourceBufferUpdateEnd",
    value: function handleSourceBufferUpdateEnd() {
      if (this.canEndStream() && this.sourceBufferAvailable()) {
        this.privMediaSource.endOfStream();
        this.notifyPlayback();
      }
    }
  }, {
    key: "notifyPlayback",
    value: function notifyPlayback() {
      var _this = this;

      if (!this.privPlaybackStarted && this.privAudio !== undefined) {
        this.privAudio.onended = function () {
          if (!!_this.onAudioEnd) {
            _this.onAudioEnd(_this);
          }
        };

        if (!this.privIsPaused) {
          this.privAudio.play();
        }

        this.privPlaybackStarted = true;
      }
    }
  }, {
    key: "canEndStream",
    value: function canEndStream() {
      return this.isClosed && this.privSourceBuffer !== undefined && this.privAudioBuffer.length === 0 && this.privMediaSourceOpened && !this.privAppendingToBuffer && this.privMediaSource.readyState === "open";
    }
  }, {
    key: "sourceBufferAvailable",
    value: function sourceBufferAvailable() {
      return this.privSourceBuffer !== undefined && !this.privSourceBuffer.updating;
    }
  }, {
    key: "format",
    set: function set(format) {
      var _this2 = this;

      if (typeof AudioContext !== "undefined") {
        this.privFormat = format;
        var mimeType = AudioFormatToMimeType[this.privFormat.formatTag];

        if (mimeType !== undefined && typeof MediaSource !== "undefined" && MediaSource.isTypeSupported(mimeType)) {
          this.privAudio = new Audio();
          this.privAudioBuffer = [];
          this.privMediaSource = new MediaSource();
          this.privAudio.src = URL.createObjectURL(this.privMediaSource);
          this.privAudio.load();

          this.privMediaSource.onsourceopen = function (event) {
            _this2.privMediaSourceOpened = true;
            _this2.privMediaSource.duration = MediaDurationPlaceholderSeconds;
            _this2.privSourceBuffer = _this2.privMediaSource.addSourceBuffer("audio/mpeg");

            _this2.privSourceBuffer.onupdate = function (_) {
              _this2.updateSourceBuffer();
            };

            _this2.privSourceBuffer.onupdateend = function (_) {
              _this2.handleSourceBufferUpdateEnd();
            };

            _this2.privSourceBuffer.onupdatestart = function (_) {
              _this2.privAppendingToBuffer = false;
            };
          };

          this.updateSourceBuffer();
        } else {
          // tslint:disable-next-line:no-console
          console.warn("Format ".concat(AudioFormatTag[this.privFormat.formatTag], " is not supported for playback."));
        }
      }
    }
  }, {
    key: "isClosed",
    get: function get() {
      return this.privIsClosed;
    }
  }, {
    key: "currentTime",
    get: function get() {
      if (this.privAudio !== undefined) {
        return this.privAudio.currentTime;
      }

      return -1;
    }
  }, {
    key: "internalAudio",
    get: function get() {
      return this.privAudio;
    }
  }]);

  return SpeakerAudioDestination;
}();